import styled, { css } from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledHeadContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 80px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	padding: 0 24px;
`;

const StyledPlayerInfoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledPlayerNameContainer = styled.div`
	.name {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}

	.online_info {
		font-size: 12px;
		color: rgba(255, 255, 255, 0.25);

		.online {
			font-weight: 500;
			color: #77de38;
		}

		.offline {
			font-weight: 500;
			color: rgba(255, 255, 255, 0.5);
		}
	}
`;

const StyledImage = styled.img<{ $online?: boolean }>`
	width: 40px;
	height: 40px;
	border-radius: 40px;

	${(props) =>
		props.$online
			? css`
					padding: 2px;
					border: 2px solid #77de38;
			  `
			: css`
					filter: grayscale(1);
			  `}
`;

const StyledImageButton = styled.img<{ $active?: boolean }>`
	user-select: none;
	opacity: ${(props) => (props.$active ? 1 : 0.5)};
	transition: opacity 0.3s ease;
	object-fit: contain;
	cursor: pointer;

	&:hover {
		opacity: 1;
	}
`;

const StyledDropdownWrapper = styled.div`
	position: absolute;
	top: 60px;
	right: 24px;
	z-index: 10;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.menu-enter {
		opacity: 0;
	}

	&.menu-enter-active,
	&.menu-enter-done,
	&.menu-exit {
		opacity: 1;
	}

	&.menu-exit-active {
		opacity: 0;
	}
`;

const StyledMessagesContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: 558px;
	overflow-y: scroll;
	padding: 24px 24px 88px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledSendContainer = styled.div`
	position: fixed;
	bottom: 20px;
	display: grid;
	grid-template-columns: 1fr 120px;
	gap: 10px;
	width: 592px;
	padding: 20px 0;
	background-color: #111111;
`;

const StyledInput = styled.input`
	width: 100%;
	height: 40px;
	padding: 12px 15px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	background-color: transparent;
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;

	&:focus {
		outline: none;
	}

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
		transition: color 0.3s ease;
		user-select: none;
	}

	&:hover {
		&::placeholder {
			color: rgba(255, 255, 255, 0.5);
		}
	}
`;

const StyledButton = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	height: 40px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	transition: background-color 0.3s ease;
	border-radius: 10px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		opacity: ${(props) => (props.$active ? 1 : 0.25)};
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;
	}

	${TextLabel} {
		font-size: 14px;
		color: ${(props) =>
			props.$active ? '#FFFFFF' : 'rgba(255, 255, 255, 0.25)'};
		transition: color 0.3s ease;
	}

	${(props) =>
		props.$active &&
		css`
			cursor: pointer;

			&:hover {
				background-color: #ffffff;

				img {
					filter: invert(1);
				}

				${TextLabel} {
					color: #000000;
				}
			}
		`}
`;

const StyledNewMessagesContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 30px;
	min-height: 30px;
	background-color: rgba(255, 62, 62, 0.1);
	border-radius: 10px;

	${TextLabel} {
		font-weight: 500;
		font-size: 12px;
		color: #ff3e3e;
	}
`;

export {
	StyledHeadContainer,
	StyledImage,
	StyledPlayerInfoContainer,
	StyledPlayerNameContainer,
	StyledImageButton,
	StyledDropdownWrapper,
	StyledMessagesContainer,
	StyledSendContainer,
	StyledInput,
	StyledButton,
	StyledNewMessagesContainer,
};
